import { EGDSSpacing } from '@egds/react-core/spacing';
import { inject } from 'mobx-react';
import * as React from 'react';
import { SharedUiSpaceDetailsWrapper } from 'components/infosite/shared-ui/offers/space-details-wrapper';
export const SpaceDetailsWrapper = inject('currentHotel')(() => React.createElement(EGDSSpacing, {
  margin: {
    block: 'six'
  }
}, React.createElement("div", null, React.createElement(SharedUiSpaceDetailsWrapper, null))));